var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetworkingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1937_4273)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.493164,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1937_4273)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint1_radial_1937_4273)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint2_radial_1937_4273)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint3_radial_1937_4273)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0785 19.2042C28.0785 17.7069 29.2922 16.4932 30.7895 16.4932C32.2867 16.4932 33.5005 17.7069 33.5005 19.2042C33.5005 20.7014 32.2867 21.9152 30.7895 21.9152C30.2238 21.9152 29.6986 21.7419 29.264 21.4455C29.2406 21.52 29.1995 21.59 29.1405 21.649L26.4516 24.3379C26.4443 24.3451 26.4369 24.3521 26.4293 24.3589C26.6196 24.6509 26.7552 24.9818 26.8214 25.3372H30.2368C30.2806 25.3372 30.3231 25.3428 30.3636 25.3534C30.5689 24.7031 31.1768 24.2317 31.8949 24.2317C32.7816 24.2317 33.5004 24.9505 33.5004 25.8372C33.5004 26.7239 32.7816 27.4427 31.8949 27.4427C31.1768 27.4427 30.5688 26.9712 30.3636 26.3209C30.3231 26.3315 30.2806 26.3372 30.2368 26.3372H26.8214C26.7523 26.708 26.6077 27.0522 26.4041 27.3534C26.4206 27.3662 26.4364 27.3802 26.4516 27.3953L30.2161 31.1598C30.2205 31.1643 30.2249 31.1688 30.2292 31.1734C30.5542 30.9774 30.935 30.8647 31.3422 30.8647C32.5342 30.8647 33.5005 31.831 33.5005 33.0229C33.5005 34.2149 32.5342 35.1812 31.3422 35.1812C30.1502 35.1812 29.184 34.2149 29.184 33.0229C29.184 32.6003 29.3054 32.2061 29.5154 31.8732C29.5132 31.8711 29.5111 31.869 29.509 31.8669L25.7445 28.1024C25.7312 28.0891 25.7188 28.0753 25.7074 28.061C25.2679 28.368 24.7332 28.5482 24.1564 28.5482C23.6114 28.5482 23.104 28.3873 22.679 28.1106L19.9982 30.7913C19.9814 30.8081 19.9637 30.8235 19.9452 30.8374C20.1292 31.155 20.2345 31.5239 20.2345 31.9174C20.2345 33.1094 19.2682 34.0757 18.0762 34.0757C16.8843 34.0757 15.918 33.1094 15.918 31.9174C15.918 30.7254 16.8843 29.7592 18.0762 29.7592C18.5147 29.7592 18.9226 29.8899 19.2631 30.1145C19.272 30.1041 19.2813 30.094 19.2911 30.0842L21.9553 27.42C21.6344 26.9747 21.4454 26.428 21.4454 25.8372C21.4454 25.2615 21.6249 24.7277 21.9309 24.2887L19.3742 21.7321C19.1515 21.849 18.8979 21.9152 18.6289 21.9152C17.7422 21.9152 17.0234 21.1964 17.0234 20.3097C17.0234 19.423 17.7422 18.7042 18.6289 18.7042C19.5156 18.7042 20.2344 19.423 20.2344 20.3097C20.2344 20.5628 20.1759 20.8022 20.0715 21.0152L22.6436 23.5872C23.0757 23.2961 23.5962 23.1262 24.1564 23.1262C24.7473 23.1262 25.2939 23.3152 25.7393 23.636C25.741 23.6342 25.7427 23.6325 25.7445 23.6308L28.4334 20.9419C28.4869 20.8883 28.5496 20.8495 28.6164 20.8253C28.2785 20.3731 28.0785 19.812 28.0785 19.2042ZM30.7895 17.4932C29.8445 17.4932 29.0785 18.2592 29.0785 19.2042C29.0785 20.1491 29.8445 20.9152 30.7895 20.9152C31.7345 20.9152 32.5005 20.1491 32.5005 19.2042C32.5005 18.2592 31.7345 17.4932 30.7895 17.4932ZM18.6289 19.7042C18.2945 19.7042 18.0234 19.9753 18.0234 20.3097C18.0234 20.6441 18.2945 20.9152 18.6289 20.9152C18.9633 20.9152 19.2344 20.6441 19.2344 20.3097C19.2344 19.9753 18.9633 19.7042 18.6289 19.7042ZM24.1564 24.1262C23.2115 24.1262 22.4454 24.8922 22.4454 25.8372C22.4454 26.7821 23.2115 27.5482 24.1564 27.5482C25.1014 27.5482 25.8674 26.7821 25.8674 25.8372C25.8674 24.8922 25.1014 24.1262 24.1564 24.1262ZM31.8949 25.2317C31.5605 25.2317 31.2894 25.5028 31.2894 25.8372C31.2894 26.1716 31.5605 26.4427 31.8949 26.4427C32.2293 26.4427 32.5004 26.1716 32.5004 25.8372C32.5004 25.5028 32.2293 25.2317 31.8949 25.2317ZM18.0762 30.7592C17.4365 30.7592 16.918 31.2777 16.918 31.9174C16.918 32.5571 17.4365 33.0757 18.0762 33.0757C18.7159 33.0757 19.2345 32.5571 19.2345 31.9174C19.2345 31.2777 18.7159 30.7592 18.0762 30.7592ZM31.3422 31.8647C30.7025 31.8647 30.184 32.3833 30.184 33.0229C30.184 33.6626 30.7025 34.1812 31.3422 34.1812C31.9819 34.1812 32.5005 33.6626 32.5005 33.0229C32.5005 32.3833 31.9819 31.8647 31.3422 31.8647Z",
    fill: "#E8BF39"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1937_4273",
    x: -7.9,
    y: -7.40684,
    width: 65.8,
    height: 65.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1937_4273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1937_4273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1937_4273",
    x1: -20,
    y1: -30.5369,
    x2: 75.8258,
    y2: 8.56886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1937_4273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-26.6228 5.60829) rotate(35.1112) scale(57.6443 34.0523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1937_4273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.6381 33.9561) rotate(161.34) scale(41.7879 28.303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD740",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1937_4273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.21518e-06 -25.5068) rotate(38.2701) scale(56.6765 40.7288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkingIcon);
export default __webpack_public_path__ + "static/media/networking_icon.48f97a25b137172cd37835d965085332.svg";
export { ForwardRef as ReactComponent };